<template>
  <div id="attivitaRegistrazione">
    <div class="imgev" v-if="attivita.imageact"
         :style="{ backgroundImage: 'url(static/image/attivita/' + attivita.imageact + ')'}"></div>
    <div v-if="step===0">
      <div class="row" style="margin-right: 0px">
        <div class="col-lg-12 directory">
          <router-link :to="{name: 'homepage'}">Home</router-link>
          /
          <router-link :to="{ path: '/attivita/'+attivita.subtype}">Attivit&agrave;</router-link>
          / Registrazione
        </div>
        <div class="col-lg-5">
          <div class="col-lg-12 categoria" id="riepilogo">{{$t('summary')}}</div>
          <div class="col-lg-12 riepilogo">
            <div class="row">
              <div class=""><img src="static/image/calendar.png" class="logo"/></div>
              <div class="titTabAttivita">
                <div class="titSez"><b>{{attivita.title}}</b></div>
              </div>
            </div>
            <div class="row">
              <div><img v-bind:src="getIcona(attivita.subtype)" class="logo"/></div>
              <div class="titTabAttivita">
                <div class="titSez"><p v-html="attivita.shortDesc"></p>
                  <p v-html="attivita.longDesc"></p></div>
              </div>
            </div>
            <div class="row">
              <div><img src="static/image/ora.png" class="logo"/></div>
              <div class="titTabAttivita">
                <div class="titSez"><b>Durata: </b><span>{{attivita.duration}} </span></div>
              </div>
            </div>
            <div class="row">
              <div><img src="static/image/prezzo.png" class="logo"/></div>
              <div class="titTabAttivita">
                <div class="titSez"><b>Costo: </b><span>{{attivita.price}} €</span></div>
              </div>
            </div>
            <div class="row">
              <div
                v-if="attivita.attachment !== null && attivita.attachment !== undefined && attivita.attachment !== ''">
                <img
                  src="static/image/pdf.png" class="logo"/></div>
              <div class="titTabAttivita">
                <div class="titSez"
                     v-if="attivita.attachment !== null && attivita.attachment !== undefined && attivita.attachment !== ''">
                  allegato: <span><a target="_blank"
                                     :href="'static/documents/' + attivita.attachment">Apri locandina</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="col-lg-12 categoria" id="form">{{$t('form')}}</div>
          <div class="col-lg-12 form">
            <div v-show="attivita.id === 4">
              <div id="form-wine-experience"></div>
            </div>
            <div v-show="attivita.id === 5">
              <div id="form-kitchen-lab"></div>
            </div>
            <div v-show="attivita.id === 6">
              <div id="form-herbs"></div>
            </div>
            <div v-show="attivita.id === 7">
              <div id="form-picnic"></div>
            </div>
            <!--            <el-form class="formRichieste" ref="form" :model="form" :rules="rules" label-width="140px">-->
            <!--              <el-form-item label="Data Attività:" id="dateform">-->
            <!--                <el-col :span="11">-->
            <!--                  <el-form-item prop="dateEvent">-->
            <!--                    <el-date-picker format="dd/MM/yyyy" :picker-options="pickerOptions1" id="dataAtt" type="date"-->
            <!--                                    placeholder="Scegli la data" v-model="form.dateEvent"></el-date-picker>-->
            <!--                  </el-form-item>-->
            <!--                </el-col>-->
            <!--                <el-col class="line" :span="2">-</el-col>-->
            <!--                <el-col :span="11">-->
            <!--                  <el-form-item prop="hourEvent">-->
            <!--                    <el-time-select id="oraAtt" placeholder="Scegli l'ora" :picker-options="rangeOrari"-->
            <!--                                    v-model="form.hourEvent"></el-time-select>-->
            <!--                  </el-form-item>-->
            <!--                </el-col>-->
            <!--              </el-form-item>-->
            <!--              <el-form-item label="Nome:" prop="name" id="nome">-->
            <!--                <el-input v-model="form.name" maxlength="120"></el-input>-->
            <!--              </el-form-item>-->
            <!--              <el-form-item label="Cognome:" prop="surname" id="cognome">-->
            <!--                <el-input v-model="form.surname" maxlength="120"></el-input>-->
            <!--              </el-form-item>-->
            <!--              <el-form-item label="Ragione Sociale:" prop="ragsoc">-->
            <!--                <el-input v-model="form.ragsoc" maxlength="120"></el-input>-->
            <!--              </el-form-item>-->
            <!--              <el-form-item label="Indirizzo Mail:" prop="mail">-->
            <!--                <el-input name="email" v-model="form.mail" maxlength="120"></el-input>-->
            <!--              </el-form-item>-->
            <!--              <el-form-item label="Cellulare:" prop="tel">-->
            <!--                <el-input type="number" v-model="form.tel" maxlength="120"></el-input>-->
            <!--              </el-form-item>-->
            <!--              &lt;!&ndash;<el-form-item label="Data di Nascita:" prop="birthday">-->
            <!--              <el-date-picker format="dd/MM/yyyy" type="date" placeholder="Scegli la data" v-model="form.birthday" style="width: 100%;"></el-date-picker>-->
            <!--              </el-form-item>&ndash;&gt;-->
            <!--              <el-form-item label="Adulti:" prop="senior">-->
            <!--                <el-input type="number" class="inputPartecipanti" v-model="form.senior"></el-input>-->
            <!--              </el-form-item>-->
            <!--              <el-form-item label="Bambini < 12 anni:">-->
            <!--                <el-input type="number" class="inputPartecipanti" v-model="form.junior"></el-input>-->
            <!--              </el-form-item>-->
            <!--              <el-form-item label="Note:">-->
            <!--                <el-input type="textarea" v-model="form.note"></el-input>-->
            <!--              </el-form-item>-->
            <!--              <el-form-item label="Privacy:" prop="privacy">-->
            <!--                <el-button type="text" @click="dialogPrivacy = true" style="width: 84%; text-align: left; padding-left: 2%;">-->
            <!--                  <el-checkbox v-model="form.privacy" label="Ho letto e accetto l'informativa sulla Privacy"-->
            <!--                               name="type"></el-checkbox>-->
            <!--                </el-button>-->
            <!--              </el-form-item>-->
            <!--              <el-form-item label="Marketing:" prop="marketing">-->
            <!--                <el-checkbox v-model="form.marketing"-->
            <!--                             label="Autorizzo il trattamento dei dati per lo svolgimento di attività promozionali, commerciali, newsletter, attraverso mailing list, compimento di attività statistiche, rilevazione del grado di soddisfazione, con strumenti automatizzati (ad esempio via e-mail, sms, mms) e con strumenti non automatizzati (telefono con operatore o posta cartacea)"-->
            <!--                             name="type"></el-checkbox>-->
            <!--              </el-form-item>-->
            <!--            </el-form>-->
          </div>
        </div>
      </div>
      <div class="row" style="width: -webkit-fill-available; margin-left: 0px; margin-right: 0px; margin-bottom: 50px">
        <div class="col-lg-12">
          <b-btn class="indietro" :to="{name: 'attivita'}">Indietro
          </b-btn>
          <!--          <b-btn class="informazioni" @click="onSubmit('form')">-->
          <!--            Procedi-->
          <!--          </b-btn>-->
        </div>
      </div>
    </div>
    <div v-if="step===1">
      <div class="row" v-bind:style="{height: pageHeight/3 + 'px'}" style="margin-right: 0px; margin-left: 0px">
        <div style="text-align: center; width: 100%; color: white; margin: auto;">
          <strong>Richiesta inoltrata correttamente</strong><br>
          Grazie per la vostra richiesta, Vi risponderemo prima possibile<br>
          <router-link :to="{name: 'attivita'}">Torna alla sezione Attività</router-link>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogPrivacy"
      width="69%"
      :before-close="handleClose">
      <h1 class="postTitle">Privacy Policy</h1>
      <div class="wpb_text_column wpb_content_element ">
        <div class="wpb_wrapper">
          Informazioni per il trattamento dei dati personali raccolti presso l’interessato (art. 13 Reg. UE 2016/679 –
          GDPR)
          In osservanza al Regolamento Generale sulla protezione dei Dati (UE) 2016/679 forniamo le dovute informazioni
          in ordine al trattamento dei dati personali effettuati attraverso il presente sito. L'informativa non è valida
          per altri siti web eventualmente consultabili tramite links presenti sul sito internet a dominio del titolare,
          che non è da considerarsi in alcun modo responsabile dei siti internet dei terzi.
          Si tratta di un'informativa che è resa ai sensi dell’art.13 del Regolamento Generale sulla protezione dei dati
          (UE) 2016/679 – GDPR. L'informativa si ispira anche alla Raccomandazione n. 2/2001 che le autorità europee per
          la protezione dei dati personali, riunite nel Gruppo istituito dall’art. 29 della direttiva n. 95/46/CE, hanno
          adottato il 17 maggio 2001 per individuare alcuni requisiti minimi per la raccolta di dati personali on-line
          e, in particolare, le modalità, i tempi e la natura delle informazioni che i titolari del trattamento devono
          fornire agli utenti quando questi si collegano a pagine web, indipendentemente dagli scopi del collegamento,
          nonché a quanto previsto dalla Direttiva 2002/58/CE, come aggiornata dalla Direttiva 2009/136/CE, in materia
          di Cookie e dal provvedimento dell'Autorità Garante "Individuazione delle modalità semplificate per
          l'informativa e l'acquisizione del consenso per l'uso dei cookie - 8 maggio 2014 (Pubblicato sulla Gazzetta
          Ufficiale n. 126 del 3 giugno 2014)" e successivi chiarimenti.
          Dato personale (art. 4 GDPR) «dato personale»: qualsiasi informazione riguardante una persona fisica
          identificata o identificabile («interessato»); si considera identificabile la persona fisica che può essere
          identificata, direttamente o indirettamente, con particolare riferimento a un identificativo come il nome, un
          numero di identificazione, dati relativi all’ubicazione, un identificativo online o a uno o più elementi
          caratteristici della sua identità fisica, fisiologica, genetica, psichica, economica, culturale o sociale;
          (C26, C30)
          Informative specifiche
          Informative specifiche potrebbero essere presentate nelle pagine del Sito in relazione a particolari servizi o
          trattamenti dei Dati forniti.
          Cookies
          Per maggiori informazioni sui cookies utilizzati dal presente sito web si veda la cookie policy al seguente <a
          href="../../static/documents/CookiePolicy.pdf" style="color: black; font-weight: bold">link</a>.
          <h4>1. IL "TITOLARE" DEL TRATTAMENTO</h4>
          Ai sensi degli artt. 4 e 24 del GDPR, il titolare del trattamento è Tenuta Ballerio Società Agricola srl, con sede in Località
          Case Nuove 9 - 27047 Case Nuove (PV) nella persona del legale rappresentante pro-tempore. L’email di contatto
          del titolare è info@tenutaballerio.com
          <h4>2. FINALITÀ E BASE GIURIDICA DEL TRATTAMENTO</h4>
          I dati personali saranno trattati nel rispetto delle condizioni di liceità ex art. 6 Reg. UE 2016/679 per le
          seguenti finalità:
          A) servizi di Tenuta Ballerio Società Agricola Srl:
          - navigazione sul presente sito internet,
          - richiesta di contatto, customer care e per richieste di informazioni sui servizi di Tenuta Ballerio Società Agricola Srl
          - raccolta dati e compilazioni di form online per aderire a servizi del Titolare;
          - acquisti on-line e attività amministrativo-contabili connesse. Ai fini dell'applicazione delle disposizioni
          in materia di protezione dei dati personali, i trattamenti effettuati per finalità amministrativo-contabili
          sono quelli connessi allo svolgimento delle attività di natura organizzativa, amministrativa, finanziaria e
          contabile, a prescindere dalla natura dei dati trattati. In particolare, perseguono tali finalità le attività
          organizzative interne, quelle funzionali all'adempimento di obblighi contrattuali e precontrattuali, attività
          informativa, spedizioni ed eventuali resi;
          B) per attività di marketing diretto, newsletters e promozioni, ricerche di mercato o altre ricerche
          campionarie e vendita diretta, rilevazione del grado di soddisfazione, tramite mezzi automatizzati posta
          elettronica, messaggi MMS o SMS, social networks e applicazioni, nonchè mediante telefonate tramite operatore
          e posta cartacea, aventi ad oggetto invio di materiale informativo, promozionale, commerciale e pubblicitario
          inerente ad eventi ed iniziative su prodotti, servizi, offerte, promozioni, da parte di Tenuta Ballerio Società Agricola Srl,
          anche attraverso le società di gestione (managing company) nominate responsabili del trattamento. I dati
          saranno inseriti nel CRM aziendale.
          C) per attività informative e promozionali verso propri Clienti. L’utilizzo delle coordinate di posta
          elettronica fornite dal cliente nel contesto della vendita di un prodotto o di un servizio a fini di vendita
          diretta di propri prodotti o servizi, è consentito ai fini di invio di informative e newsletter.
          L'interessato, al momento della raccolta e in occasione dell'invio di ogni comunicazione, è informato della
          possibilità di opporsi in ogni momento al trattamento, in maniera agevole e gratuitamente (art. 130 comma 4
          del D.Lgs. 196/03). Per cancellarsi dalla mailing list sarà sufficiente scrivere in qualsiasi momento una
          e-mail all’indirizzo e-mail info@tenutaballerio.com ovvero per posta all’indirizzo fisico del titolare sopra indicato
          (sede) con oggetto “cancellazione mailing list”.
          Il trattamento dati ai sensi della finalità A) si basa sull’esecuzione di un contratto di cui l’interessato è
          parte o sull’esecuzione di misure precontrattuali adottate su richiesta dell’interessato.
          Il trattamento dati ai sensi della finalità B) si basa sul consenso ex. articolo 6, paragrafo 1, lettera a)
          GDPR.
          Il trattamento dati ai sensi della finalità C) si basa sul legittimo interesse del Titolare ex. articolo 6,
          paragrafo 1, lettera f) GDPR.
          <h4>4. DESTINATARI O CATEGORIE DI DESTINATARI DEI DATI</h4>
          I dati di natura personale forniti saranno comunicati a destinatari, che tratteranno i dati in qualità di
          responsabili (art. 28 del Reg. UE 2016/679) o di autonomi titolari. Più precisamente, i dati saranno
          comunicati a: società contrattualmente legate a Tenuta Ballerio Società Agricola Srl, a società collegate e/o controllate
          all'interno dell'Unione Europea e in paesi extra UE, in conformità della normativa vigente, anche attraverso
          le società di gestione (managing company). I dati potranno essere comunicati a terzi appartenenti alle
          seguenti categorie:
          - alla rete di vendita/distributiva su territorio;
          - soggetti che forniscono servizi per la gestione del sistema informativo usato da Tenuta Ballerio Società Agricola Srl e delle
          reti di telecomunicazioni (ivi compresa la posta elettronica, gestione Data Base CRM e mailing list,
          piattaforme e-commerce, fornitori APP, ecc…);
          - soggetti terzi per supporto ad acquisti on-line e attività amministrativo-contabili connesse, spedizioni ed
          eventuali resi (es. banche, assicurazioni, spedizionieri);
          - studi o società nell'ambito di rapporti di assistenza e consulenza;
          - autorità competenti per adempimenti di obblighi di leggi e/o di disposizioni di organi pubblici, su
          richiesta. I soggetti appartenenti alle categorie suddette svolgono la funzione di Responsabile del
          trattamento dei dati, oppure operano in totale autonomia come distinti Titolari del trattamento. L'elenco dei
          responsabili è costantemente aggiornato e disponibile presso la sede di Tenuta Ballerio Società Agricola Srl .
          I dati saranno inoltre comunicati alle persone fisiche autorizzate che agiscono sotto l’autorità del Titolare
          e del Responsabile (art. 29 del Reg. UE 2016/679), per le finalità sopra elencate.
          <h4>5. TRASFERIMENTO DEI DATI VERSO UN PAESE TERZO E/O UN’ORGANIZZAZIONE INTERNAZIONALE E GARANZIE</h4>
          Per gestire le proprie attività di commercio elettronico, Tenuta Ballerio Società Agricola Srl potrà avvalersi di piattaforme
          cloud fornite da operatori terzi in qualità di responsabili del trattamento. A tale riguardo, La informiamo
          che i Suoi dati personali saranno conservati presso server situati in Italia.
          <h4>6. PERIODO DI CONSERVAZIONE DEI DATI O CRITERI PER DETERMINARE IL PERIODO</h4>
          Il trattamento sarà svolto in forma automatizzata e manuale, con modalità e strumenti volti a garantire la
          massima sicurezza e riservatezza, ad opera di soggetti di ciò appositamente autorizzati e incaricati. Nel
          rispetto di quanto previsto dall’art. 5 comma 1 lett. e) del Reg. UE 2016/679, i dati personali raccolti
          verranno conservati in una forma che consenta l’identificazione degli interessati per un arco di tempo non
          superiore al conseguimento delle finalità per le quali i dati personali sono trattati. La conservazione dei
          dati di natura personale forniti dipende dalla finalità del trattamento:
          - navigazione sul presente sito web (si veda la cookies policy al seguente <a
          href="../../static/documents/CookiePolicy.pdf" style="color: black; font-weight: bold">link</a> );
          - per richiesta di contatto (massimo 1 anno);
          - ricezione newsletter o comunicazioni promozionali in genere via e-mail (massimo 24 mesi);
          - vendite online (10 anni)
          Per avere maggiori informazioni in merito ai criteri di data retention, l’interessato può rivolgersi via mail
          al titolare del trattamento, all’indirizzo info@tenutaballerio.com
          <h4>7. DIRITTI DEGLI INTERESSATI</h4>
          L’interessato può far valere i suoi diritti come espressi dal Regolamento UE 2016/679, rivolgendosi al
          Titolare via e-mail all’indirizzo info@tenutaballerio.com o scrivendo alla sede del Titolare sopra indicata.
          L’interessato ha il diritto, in qualunque momento, di chiedere al Titolare del trattamento l’accesso ai Suoi
          dati personali (art. 15), la rettifica (art. 16) o la cancellazione (art 17) degli stessi, o la limitazione
          del trattamento (art 18) o di opporsi al loro trattamento per attività di marketing (art. 21). Infine,
          l’interessato ha il diritto alla portabilità del dato (art. 20).
          Revoca del consenso. Qualora il trattamento sia basato sul consenso, l’interessato ha il diritto di revocare
          il consenso in qualsiasi momento senza pregiudicare la liceità del trattamento basata sul consenso prestato
          prima della revoca.
          Per opporsi al trattamento e per esercitare gli altri diritti, l’interessato potrà scrivere a
          info@tenutaballerio.com.
          Non viene effettuato un processo decisionale automatizzato (art. 22).
          Ai sensi della Normativa Applicabile, l’interessato ha in ogni caso il diritto di proporre reclamo
          all’autorità di controllo competente (Garante per la Protezione dei Dati Personali) qualora ritenesse che il
          trattamento dei suoi Dati Personali sia contrario alla normativa vigente.
          <h4>8. NATURA DEL CONFERIMENTO E RIFIUTO</h4>
          Il conferimento dei dati per le finalità di cui al punto A) è facoltativo ma necessario. L'eventuale rifiuto
          del conferimento dei dati necessari rispetto al punto A) comporta l'impossibilità di usufruire dei servizi del
          Titolare del trattamento. Il conferimento e il consenso al trattamento per le finalità di cui al punto B) è
          facoltativo. L'eventuale rifiuto del consenso per la finalità illustrata nel punto B) sopra riportato, non
          comporta alcuna conseguenza negativa riguardo le finalità di cui al punto A). L’attività di marketing è solo
          eventuali e sarà realizzata solamente con il consenso specifico dell’interessato.
          <h4>9. MODIFICHE ALL'INFORMATIVA SULLA PRIVACY</h4>
          Il Titolare si riserva il diritto di modificare, aggiornare, aggiungere o rimuovere parti della presente
          informativa sulla privacy a propria discrezione e in qualsiasi momento. La persona interessata è tenuta a
          verificare periodicamente le eventuali modifiche. Al fine di facilitare tale verifica, l'informativa conterrà
          l'indicazione della data di aggiornamento.
          Data di aggiornamento: novembre 2018
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="setPrivacy('')">Rifiuta</el-button>
    <el-button type="primary" @click="setPrivacy(true)">Accetta</el-button>
  </span>
    </el-dialog>
    <Footer></Footer>
  </div>
</template>

<script>
import MainSlider from './MainSlider'
import Footer from './Footer'
import moment from 'moment'

export default {
  name: 'attivitaregistrazione',
  components: {MainSlider, Footer},
  data () {
    var checkMail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Inserire email'))
      }
      setTimeout(() => {
        if (!this.validateEmail(value)) {
          callback(new Error('Email non valida'))
        } else {
          callback()
        }
      }, 500)
    }
    return {
      activities: [
        {
          "id": 24,
          "state": "A",
          "type": "ACT",
          "subtype": "VSCAN",
          "dateFrom": "Jan 1, 2019 12:00:00 AM",
          "dateTo": "Dec 31, 2019 12:00:00 AM",
          "duration": "90 min",
          "price": 25.0,
          "maxSize": 80,
          "imageact": "cantinaWineTourPlus.jpg",
          "image": "winetour.png",
          "language": "ita",
          "title": "Wine Tour \"Plus\"",
          "shortDesc": "Un'entusiasmante visita guidata alla scoperta del vino di qualit&agrave; dalla vigna al bicchiere assaporando la ricca offerta gastronomica dell'Oltrep&ograve; Pavese.<br><br><b>Nota bene: l'attività sarà disponibile al raggiungimento di almeno 10 partecipanti negli orari 10:30 e 15:00.</br>Il tour verrà confermato entro 72 ore dalla data del tour stesso.",
          "longDesc": "Il tour comprende:<ul><li>visita dei vigneti</li><li>visita della cantina</li><li>visita della barricaia</li><li>degustazione di 4 vini</li><li>Selezione di salumi e formaggi locali, pane e focaccia</li></ul>"
        },
        {
          "id": 3,
          "state": "A",
          "type": "ACT",
          "subtype": "VSCAN",
          "dateFrom": "Jan 1, 2019 12:00:00 AM",
          "dateTo": "Dec 31, 2019 12:00:00 AM",
          "duration": "90 min",
          "price": 25.0,
          "maxSize": 6,
          "imageact": "cantinaWineTourBotte.jpg",
          "image": "botte.png",
          "language": "ita",
          "title": "Degustazione in botte",
          "shortDesc": "Un'entusiasmante visita guidata alla scoperta del vino di qualit&agrave; dalla vigna al bicchiere assaporando la ricca offerta gastronomica dell'Oltrep&ograve; Pavese all'INTERNO DI UNA BOTTE da 60 hl!<br><br><b>Nota bene: la disponibilità dipende dalle condizioni meteo e dalla programmazione dei tour giornalieri. <br/> MAX 2 PERSONE</b>",
          "longDesc": "Il tour comprende:</ul><li>visita dei vigneti</li><li>visita della cantina</li><li>visita della barricaia</li><li>degustazione di 3 vini</li><li>Selezione di Salumi e formaggi locali, pane e focaccia</li></ul>"
        }
      ],
      pageHeight: window.innerHeight,
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      dialogPrivacy: false,
      step: 0,
      attivita: {
        dateFrom: '',
        dateTo: '',
        duration: '',
        id: '',
        longDesc: '',
        maxSize: 0,
        price: 0,
        shortDesc: '',
        state: '',
        subtype: '',
        title: '',
        type: 'EVE'
      },
      form: {
        name: '',
        surname: '',
        mail: '',
        tel: '',
        dateEvent: '',
        hourEvent: '',
        senjor: '',
        junior: '',
        note: '',
        privacy: '',
        marketing: ''
      },
      rules: {
        name: [
          {required: true, message: 'Inserire il nome', trigger: 'blur'}
        ],
        surname: [
          {required: true, message: 'Inserire il cognome', trigger: 'blur'}
        ],
        mail: [
          {required: true, message: 'Inserire email', trigger: 'blur'},
          {validator: checkMail, trigger: 'blur'}
        ],
        tel: [
          {required: true, message: 'Inserire il telefono', trigger: 'blur'}
        ],
        dateEvent: [
          {type: 'date', required: true, message: 'Inserire la data', trigger: 'change'}
        ],
        hourEvent: [
          {required: true, message: 'Scegliere orario', trigger: 'change'}
        ],
        senior: [
          {required: true, message: 'Inserire il numero di adulti', trigger: 'blur'}
        ],
        privacy: [
          {required: true, message: 'Accettare il documento sulla privacy', trigger: 'change'}
        ]
      },
      rangeOrari: {
        start: '10:30',
        step: '04:30',
        end: '15:00'
      }
    }
  },
  i18n: {
    fallbackLocale: 'it', // default lang,
    messages: {
      it: {
        summary: 'Riepilogo',
        form: 'Compila la richiesta'
      },
      en: {
        summary: 'Summary',
        form: 'Fill in the request'
      }
    }
  },
  mounted: function () {
    this.getAttivita()
    window.scroll(0, 0)
    if (window.hbspt) {
      hbspt.forms.create({
        portalId: '5864348',
        formId: 'd3a8533d-269b-49b0-a400-132dfd93c9ca',
        target: '#form-wine-experience'
      })

      hbspt.forms.create({
        portalId: '5864348',
        formId: '0a8a9079-efa7-48dd-a4ff-eb28e6ba0b21',
        target: '#form-kitchen-lab'
      })

      hbspt.forms.create({
        portalId: '5864348',
        formId: '0a8a9079-efa7-48dd-a4ff-eb28e6ba0b21',
        target: '#form-herbs'
      })

      hbspt.forms.create({
        portalId: '5864348',
        formId: '4ff592d1-e823-4564-b330-d0eb59182049',
        target: '#form-picnic'
      })
    }
  },
  methods: {
    validateEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    handleClose (done) {
      this.$confirm('Are you sure to close this dialog?')
        .then(_ => {
          done()
        })
        .catch(_ => {
        })
    },
    getAttivita: function () {
      let activity = this.activities.filter((el) => el.id === parseInt(this.$route.params.id))
      this.$set(this, 'attivita', activity[0])
    },
    setAttivita: function () {
      let lang = this.$root.$i18n.locale === 'it' ? 'ita' : 'eng'
      let data = {
        'type': 'ACT',
        'itemId': parseInt(this.$route.params.id),
        'name': this.form.name,
        'surname': this.form.surname,
        'mail': this.form.mail,
        'tel': this.form.tel,
        'privacy': parseInt(this.form.privacy),
        'marketing': parseInt(this.form.marketing),
        'senjor': parseInt(this.form.senior),
        'junior': parseInt(this.form.junior),
        'dateFrom': moment(this.form.dateEvent).format('YYYY-MM-DD'),
        'dateTo': moment(this.form.dateEvent).format('YYYY-MM-DD'),
        'hour': this.form.hourEvent + ':00'
      }
      this.step = 1
    },
    /* $set rende reattivo un attributo annidato in un json del data */
    setPrivacy: function (value) {
      this.dialogPrivacy = false
      this.$set(this.form, 'privacy', value)
    },
    onSubmit (formName) {
      this.$validator.validate().then(result => {
        if (result) {
          this.registrazione(formName)
        } else {
          // console.log('error submit!!')
        }
      })
    },
    registrazione (formName) {
      // this.$gtag.event('registrazioneAttivita', {value: 'submit'})
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.marketing === true) this.form.marketing = 1
          else this.form.marketing = 0
          if (this.form.privacy === true) this.form.privacy = 1
          else this.form.privacy = 0
          this.setAttivita()
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    getIcona: function (tipoEvento) {
      if (tipoEvento === 'VSCAN') return './static/image/default.png'
      if (tipoEvento === 'PICNI') return './static/image/attivita/picnic.png'
      if (tipoEvento === 'TRAIN') return './static/image/corso.png'
      if (tipoEvento === 'BIKE') return './static/image/bikepoint.png'
      else return './static/image/default.png'
    },
    capitalizeFirstLetter: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    '$i18n.locale': function () {
      this.getAttivita()
    }
  }
}
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #attivitaRegistrazione {
    background-color: @darkGray;

    input {
      background-color: @lightBlack;
      border-color: #535455;
      color: white;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: initial;
      margin: 0;
    }

    .imgev {
      background-size: cover;
      background-position: center;
      height: 500px;
    }

    .directory {
      padding-left: 75px;
      padding-top: 30px;
      letter-spacing: 1px;
      .set-font(@size: 13px);
    }

    .categoria {
      width: 80%;
      margin: auto;
      text-align: center;
      padding: 20px;
      border-bottom: 1px solid white;
      .set-font-title();
    }

    .riepilogo {
      border: .5px;
      border-style: solid;
      border-color: white;
      width: 80%;
      margin: auto;
      margin-top: 25px;
      background-color: @lightBlack;
      padding: 30px;
      letter-spacing: 1px;
      .set-font();

      .logo {
        padding-right: 15px;
      }

      .titTabAttivita {
        width: 80%;

        .titSez {
          padding-top: 15px;
        }
      }
    }

    .form {
      border: .5px;
      border-style: solid;
      border-color: white;
      text-align: center;
      width: 80%;
      margin: auto;
      margin-top: 25px;
      margin-bottom: 50px;
      background-color: @lightBlack;
      padding: 30px;
      letter-spacing: 1px;

      #dateform {
        display: flex;

        .el-form-item__content {
          margin-left: 10px !important;
        }
      }

      .el-form-item__label {
        width: 30% !important;
        .set-font(@size: 14px);
      }

      .el-checkbox {
        display: inline-flex;
        width: 80%;

        .el-checkbox__label {
          white-space: pre-wrap !important;
        }
      }

      .el-input {
        width: 80%;

        .el-input__inner {
          width: 100%;
        }
      }

      .el-textarea {
        width: 80%;

        .el-textarea__inner {
          width: 100%;
          background-color: @lightBlack;
          border-color: #535455;
          color: white;
        }
      }
    }

    .indietro {
      float: left;
      width: 230px;
      background-color: @lightBlack;
      border-color: white;
      margin-left: 7%;
      text-align: center;
      letter-spacing: 1px;
      height: 40px;
      .set-font()
    }

    .informazioni {
      float: right;
      width: 230px;
      background-color: @myOrange;
      border-color: @borderOrange;
      margin: auto;
      margin-right: 7%;
      text-align: center;
      letter-spacing: 1px;
      margin-bottom: 30px;
      .set-font()
    }

    .categoria:after {
      border: 1px solid white;
    }

    .el-dialog__wrapper {
      .el-dialog {
        .el-dialog__body {
          height: 500px !important;
          overflow-y: scroll !important;
        }
      }
    }
  }

  @media (max-width: 1024px) {
    #attivitaRegistrazione {
      h1 {
        font-size: 1.5rem;
      }

      .imgev {
        height: 250px;
      }

      .directory {
        padding-left: 35px;
        padding-bottom: 15px;
        letter-spacing: 1px;
        .set-font(@size: 11px);
      }

      .categoria {
        padding: 15px;
        .set-font-title(@size: 22px);
      }

      .riepilogo {
        padding: 20px;
        .set-font(@size: 11px);

        .logo {
        }

        .titTabAttivita {
          width: 100%;

          .titSez {
            padding-top: 0px;
          }
        }
      }

      .form {
        padding: 10px;
        margin-bottom: 30px;

        #dateform {
          display: block;

          .el-form-item__content {
            margin-left: 0px !important;

            .el-col-11 {
              width: 70% !important;
            }
          }

          .el-input {
            width: 100%;

            .el-input__inner {
              margin: 5px;
            }
          }
        }

        .el-form-item__label {
          float: inherit;
          width: 100% !important;
          text-align: left;
          .set-font(@size: 11px);
        }

        .el-form-item__content {
          margin-left: 0px !important;

          .el-button {
            .el-checkbox {
              white-space: pre-wrap;

              .el-checkbox_input {
                .el-checkbox_label {
                  white-space: pre-wrap;
                }
              }
            }
          }
        }

        .el-input {
          width: 100%;

          .el-input__inner {
          }
        }

        .el-textarea {
          width: 100%;

          .el-textarea__inner {
          }
        }
      }

      .indietro {
        height: 30px;
        width: 130px;
        margin-left: 3%;
        .set-font(@size: 11px)
      }

      .informazioni {
        width: 130px;
        margin-right: 3%;
        .set-font(@size: 11px)
      }

      .categoria:after {
      }

      .el-checkbox_label {
        white-space: pre-wrap;
      }

      .el-dialog__wrapper {
        .el-dialog {
          width: 90% !important;

          .el-dialog__body {
            height: 300px !important;
          }

          .el-dialog__footer {
            .el-button {
              margin-left: 10px;
            }
          }
        }
      }
    }

    .el-message-box__wrapper {
      .el-message-box {
        width: 300px;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {

  }

  @media (min-width: 1025px) and (max-width: 1366px) {

  }
</style>



// WEBPACK FOOTER //
// src/components/AttivitaRegistrazione.vue